import { render, staticRenderFns } from "./IconStandard.vue?vue&type=template&id=3d04a680&"
import script from "./IconStandard.vue?vue&type=script&lang=js&"
export * from "./IconStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports